/* @flow */
import AlertDialog from 'components/AlertDialog.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';

class SafetyModal extends React.Component {
  static propTypes = {
    onOkay: React.PropTypes.func,
  };

  render() {
    const titleText = 'Help keep Remind safe ✨';
    const title = (
      <TextWithEntities text={titleText} entities={TextEntities.parseEmoji(titleText)} />
    );
    const subtext = (
      <span>
        Remind is built for education, so your school administrator can request the message history
        for any group. Check out our
        {' '}
        <Link href={LinkConstants.COMMUNITY_GUIDELINES} target="_blank">Community Guidelines</Link>
        {' '}
        for tips on safe communication.
      </span>
    );

    return (
      <AlertDialog
        eventScreenName="SafetyModal"
        title={title}
        subtext={subtext}
        buttonText="Got it"
        onOkay={this.props.onOkay}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}

export default SafetyModal;



// WEBPACK FOOTER //
// ./src/user/components/SafetyDialog.jsx